function isAcceptedOpenOrClosed(path) {
  if (!path) {
    return false;
  }
  return path.indexOf('accepted/open') > -1 || path.indexOf('accepted/closed') > -1;
}

export default isAcceptedOpenOrClosed;
